var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.96875C8.85938 0.96875 10.4544 1.63411 11.7852 2.96484C13.1159 4.27734 13.7812 5.8724 13.7812 7.75C13.7812 9.6276 13.1159 11.2318 11.7852 12.5625C10.4727 13.875 8.8776 14.5312 7 14.5312C5.26823 14.5312 3.75521 13.9479 2.46094 12.7812C2.27865 12.6354 2.26953 12.4805 2.43359 12.3164L3.52734 11.2227C3.67318 11.0768 3.81901 11.0677 3.96484 11.1953C4.83984 11.9609 5.85156 12.3438 7 12.3438C8.27604 12.3438 9.35156 11.8971 10.2266 11.0039C11.1198 10.1107 11.5755 9.03516 11.5938 7.77734C11.612 6.48307 11.1562 5.38932 10.2266 4.49609C9.3151 3.58464 8.23047 3.13802 6.97266 3.15625C5.76953 3.17448 4.73047 3.58464 3.85547 4.38672L5.00391 5.53516C5.20443 5.73568 5.25 5.97266 5.14062 6.24609C5.03125 6.51953 4.83073 6.65625 4.53906 6.65625H0.875C0.692708 6.65625 0.53776 6.59245 0.410156 6.46484C0.282552 6.33724 0.21875 6.18229 0.21875 6V2.33594C0.21875 2.04427 0.355469 1.84375 0.628906 1.73438C0.902344 1.625 1.13932 1.67057 1.33984 1.87109L2.32422 2.85547C3.61849 1.59766 5.17708 0.96875 7 0.96875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlip);
export default __webpack_public_path__ + "static/media/flip.f39b1de9dedc3c52ff23116d093876f8.svg";
export { ForwardRef as ReactComponent };